/* eslint-disable @typescript-eslint/no-explicit-any */

interface Config {
  creLeadHostUi: {
    leadServiceUrl: string;
    leadUiAppUrl: string;
    env: string;
    oneTrustDomainScript: string;
  };
}

const getConfig = () => {
  if ((window as any)["uiConfig"]) {
    return (window as any)["uiConfig"] as Config;
  }
  else{
    throw new Error("UI Configs are not loaded. Failed to load the App");
  }
};
export const getEnv = () => getConfig().creLeadHostUi.env;
export const getLeadServiceUrl = () => getConfig().creLeadHostUi.leadServiceUrl;
export const getLeadUiAppUrl = () => getConfig().creLeadHostUi.leadUiAppUrl;
export const getOneTrustDomainScript = () => getConfig().creLeadHostUi.oneTrustDomainScript;
export const hideHeaderFooter = () => window.location.href.indexOf("/marketinglead") > -1 ||
window.location.href.indexOf("/agency") > -1;
